// types
import formatCurrency from 'src/compass/shared/util/formatCurrency';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

/*
    Display label with value as amount.
*/

type IItem = {
  label: string;
  value: number;
};

export function CasRenderArrayOfLabelWithCurrency(props: ICasRenderCellProps) {
  return getCasTableCellValue(props)
    ?.map((item: IItem) => `${item.label}: ${formatCurrency(item.value)}`)
    .join(' \n');
}
